import React from "react";
import { Link } from "react-router-dom";

const AdminDashboard = () => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-pink-100 via-blue-100 to-purple-100 flex flex-col">
      {/* Navbar */}
      <nav className="bg-white/30 backdrop-blur-lg shadow-md border border-white/40 px-6 py-4 flex justify-between items-center">
        <div className="font-bold text-lg">5Buddies Admin</div>
        <div className="flex gap-6">
          <Link to="/shop" className="hover:text-blue-600">Shop</Link>
          <Link to="/cart" className="hover:text-blue-600">Cart</Link>
          <Link to="/authlogin" className="hover:text-blue-600">Logout</Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 flex flex-col items-center justify-center p-8">
        <h1 className="text-3xl font-semibold mb-10 text-gray-700">
          Admin Dashboard
        </h1>

        {/* Glass Tiles */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 w-full max-w-5xl">
          <Link
            to="/admin/products"
            className="bg-white/30 backdrop-blur-lg rounded-2xl shadow-lg border border-white/40 p-8 text-center hover:shadow-xl transition cursor-pointer"
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Manage Products
            </h2>
            <p className="text-gray-600">Add, update, or delete products.</p>
          </Link>

          <Link
            to="/admin/orders"
            className="bg-white/30 backdrop-blur-lg rounded-2xl shadow-lg border border-white/40 p-8 text-center hover:shadow-xl transition cursor-pointer"
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Manage Orders
            </h2>
            <p className="text-gray-600">Track and update order status.</p>
          </Link>

          <Link
            to="/admin/users"
            className="bg-white/30 backdrop-blur-lg rounded-2xl shadow-lg border border-white/40 p-8 text-center hover:shadow-xl transition cursor-pointer"
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Manage Users
            </h2>
            <p className="text-gray-600">View and control user accounts.</p>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white/30 backdrop-blur-lg border-t border-white/40 py-4 text-center text-gray-600">
        © 2025 5Buddies Admin Panel
      </footer>
    </div>
  );
};

export default AdminDashboard;
